export default {
    path: "/",
    alias: "/home",
    component: () => import("~/pages/home/index.vue"),
}